module.exports = __webpack_public_path__ + "static/media/turnip.57a13209.png";